import { Middleware } from '@reduxjs/toolkit';

import { togglePresentationMode } from '../../features/ui/uiSlice';
import StorageService from '../../services/StorageService';
import { PRESENTATION_MODE_KEY } from '../constants/storageKeys';

export const presentationModeStorageMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (
    typeof action === 'object' &&
    action !== null &&
    'type' in action &&
    action.type === togglePresentationMode.type
  ) {
    const state = store.getState();
    StorageService.setValue(PRESENTATION_MODE_KEY, state.ui.presentationMode);
  }

  return result;
};
